import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import {
  formatDuration,
  getTodayActivityPercentage,
  getTimestampFromDateTime,
} from "./../../helpers/stubs";
import Axios from "../../axios";
import moment from "moment-timezone";
import styles from "./TimeView.module.css";
import ActivityPercentage from "../ActivityPercentage/ActivityPercentage";

function TimeView({ today, totalWorkDuration, candidateId }) {
  const { weeklyDuration, monthTimeline, workSlots, selectedDay } = useSelector(
    (state) => state.candidateSlice
  );
  const {
    sessionUser,
    sessionUser: { timezone },
  } = useSelector((state) => state.sessionSlice);

  const activityPercentage = getTodayActivityPercentage(workSlots);

  const monthTotalDuration = monthTimeline.reduce(
    (prevValue, currentValue) => prevValue + currentValue.duration,
    0
  );
  const [timeSpentForMonth, setTimeSpentForMonth] = useState(0);
  const [timeSpentForWeek, setTimeSpentForWeek] = useState(0);
  const [candidateUserIdCache, setCandidateUserIdCache] = useState(new Map());

  // Helper function to get date string in specified timezone
  const getDateStringInTimezone = (date, timezone) => {
    return moment(date).tz(timezone).format('YYYY-MM-DD');
  };

  // Async helper function to get the correct user ID for API calls
  const getUserIdForApiCall = useCallback(async () => {
    if (workSlots[0]) {
      // When workSlots exist, use the user from workSlots
      return workSlots[0].user;
    } else if (candidateId) {
      // Check cache first
      if (candidateUserIdCache.has(candidateId)) {
        console.log('Using cached userId for candidateId:', candidateId);
        return candidateUserIdCache.get(candidateId);
      }
      
      // Fetch candidate's user ID if not cached
      console.log('Fetching candidate userId for candidateId:', candidateId);
      try {
        const response = await Axios.get(`/api/orgAdmin/search-candidates?query=${null}&&selectAllCandidates=${true}`);
        const candidates = response.data.result;
        const candidate = candidates.find(c => c._id === candidateId);
        
        if (candidate && candidate.userId) {
          console.log('Found candidate userId:', candidate.userId);
          // Cache the result for future use
          setCandidateUserIdCache(prev => new Map(prev.set(candidateId, candidate.userId)));
          return candidate.userId;
        } else {
          console.error('Candidate not found or userId not available for candidateId:', candidateId);
          // Fallback to admin's ID
          return sessionUser._id;
        }
      } catch (error) {
        console.error('Failed to fetch candidate details:', error);
        // Fallback to admin's ID
        return sessionUser._id;
      }
    } else {
      // When no candidateId and no workSlots, use logged-in user's ID
      return sessionUser._id;
    }
  }, [workSlots, candidateId, candidateUserIdCache, sessionUser._id]);

  useEffect(() => {
    setTimeSpentForMonth(0);
    async function calculateAndSetTimespentformonth() {
      // Calculate month boundaries in the selected timezone
      const selectedMoment = moment(selectedDay).tz(timezone);
      const monthStart = selectedMoment.clone().startOf("month");
      const monthEnd = selectedMoment.clone().endOf("month");
      
      // Get date strings in the timezone
      const fromDateStr = getDateStringInTimezone(monthStart, timezone);
      const toDateStr = getDateStringInTimezone(monthEnd, timezone);
      
      // Create proper timestamps using timezone
      const startOfMonth = getTimestampFromDateTime(fromDateStr, "00:00", timezone);
      const endOfMonth = getTimestampFromDateTime(toDateStr, "23:59", timezone);
      
      console.log(startOfMonth, endOfMonth, "month")
      const id = await getUserIdForApiCall();

      const { data } = await Axios.get(
        `/api/candidate/get-dashboard-by-timeperiod/${id}?fromDate=${startOfMonth}&toDate=${endOfMonth}&timezone=${timezone}`
      );
      console.log('month response', data);
      const timespent = data?.dashboardData[0]?.supervisingClient?.totalDuration || 0;
      setTimeSpentForMonth(timespent);
    }
    calculateAndSetTimespentformonth();
  }, [selectedDay, workSlots, timezone, candidateId, getUserIdForApiCall]);

  useEffect(() => {
    setTimeSpentForWeek(0);
    async function calculateAndSetTimespentforweek() {
      // Calculate week boundaries in the selected timezone
      const selectedMoment = moment(selectedDay).tz(timezone);
      const weekStart = selectedMoment.clone().startOf('isoWeek'); // Monday
      const weekEnd = selectedMoment.clone().endOf('isoWeek'); // Sunday
      
      // Get date strings in the timezone
      const fromDateStr = getDateStringInTimezone(weekStart, timezone);
      const toDateStr = getDateStringInTimezone(weekEnd, timezone);
      
      // Create proper timestamps using timezone
      const startOfWeek = getTimestampFromDateTime(fromDateStr, "00:00", timezone);
      const endOfWeek = getTimestampFromDateTime(toDateStr, "23:59", timezone);

      console.log(startOfWeek + "dddddddddd" + endOfWeek, selectedDay, "week",);
      const id = await getUserIdForApiCall();
      
      const { data } = await Axios.get(
        `/api/candidate/get-dashboard-by-timeperiod/${id}?fromDate=${startOfWeek}&toDate=${endOfWeek}&timezone=${timezone}`
      );
      console.log('week response', data);
      const timespent = data?.dashboardData[0]?.supervisingClient?.totalDuration || 0;
      setTimeSpentForWeek(timespent);
    }
    calculateAndSetTimespentforweek();
  }, [selectedDay, workSlots, timezone, candidateId, getUserIdForApiCall]);

  return (
    <div className={`text-center ${styles.timeview}`}>
      <Row className="justify-content-center">
        <h5>{today}</h5>
      </Row>
      <Row className="justify-content-center fs-3">
        {formatDuration(totalWorkDuration)}
      </Row>
      <Row className="justify-content-center">
        <Col>
          <span>Activity :</span>
          <ActivityPercentage activityPercentage={activityPercentage} />
        </Col>
      </Row>
      <Row className="justify-content-start">
        <span className="justify-content-start">
          Time spent for week :{formatDuration(Math.floor(timeSpentForWeek))}
        </span>
      </Row>
      <Row className="justify-content-start">
        <span className="justify-content-start">
          Time spent for Month :{formatDuration(Math.floor(timeSpentForMonth))}
        </span>
      </Row>
    </div>
  );
}

export default TimeView;
